export const medicineInventoryTranslations = {
    en: {
        // Page Title
        medicineInventoryFor: "Medicine Inventory for",
        allCampaigns: "All Campaigns",

        // Table Headers
        srNo: "Sr No",
        medicineName: "Medicine Name",
        quantity: "Quantity",
        addedBy: "Added By",
        addedOnDate: "Added On Date",

        // Buttons
        addMedicine: "Add Medicine",

        // Drawer Titles
        addMedicineFor: "Add Medicine for",

        // Messages
        failedToFetchMedicines: "Failed to fetch medicines",

        // Common
        notAvailable: "N/A",
        unknown: "Unknown",

        // Module Name
        medicineInventoryModule: "Medicine Inventory",
    },
    mr: {
        // Page Title
        medicineInventoryFor: "औषधसाठी यादी",
        allCampaigns: "सर्व मोहिमा",

        // Table Headers
        srNo: "अ. क्र.",
        medicineName: "औषधाचे नाव",
        quantity: "प्रमाण",
        addedBy: "द्वारे जोडले",
        addedOnDate: "तारखेला जोडले",

        // Buttons
        addMedicine: "औषध जोडा",

        // Drawer Titles
        addMedicineFor: "औषधसाठी जोडा",

        // Messages
        failedToFetchMedicines: "औषधे आणण्यात अयशस्वी",

        // Common
        notAvailable: "उपलब्ध नाही",
        unknown: "अज्ञात",

        // Module Name
        medicineInventoryModule: "औषध यादी",
    }
};
